var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.063,
    height: 13.41,
    viewBox: "0 0 14.063 13.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 14.063,
    height: 13.41,
    transform: "translate(0 0)",
    fill: "#f5a526"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M14.062,5.234a.335.335,0,0,1-.114.226L10.491,8.5l1.009,4.49a.342.342,0,0,1-.509.37h0l-3.96-2.349-3.96,2.349a.343.343,0,0,1-.469-.121h0a.339.339,0,0,1-.035-.266L3.574,8.5.116,5.46a.343.343,0,0,1,.221-.6l4.556-.424L6.717.208a.343.343,0,0,1,.451-.18h0a.34.34,0,0,1,.18.18L9.17,4.436l4.583.427a.342.342,0,0,1,.309.371",
    transform: "translate(0 0)",
    fill: "#f5a526"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a2915404d108e2369324b9c42f199a99.svg";
export { ForwardRef as ReactComponent };